<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-pt-6">
    <MemberCardIndex />
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import MemberCardIndex from '../../customer/customer-member-card/index.vue'

export default {
  name: 'memberContent',
  components: {
    MemberCardIndex
  },
  data() {
    return {
      errors: new Errors(),
    }
  },
  methods: {}
}
</script>
<style>
.ant-notification {
  z-index: 1030;
}
</style>